import React, { useRef, useState, useEffect } from 'react';
import * as styles from './AWProducts.module.css';
import * as generalStyles from './AWGeneral.module.css';
export const AWProducts: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [progress, setProgress] = useState(0);
    const progressRef = useRef(0);
    const targetRef = useRef(0);
    const isScrollingDownRef = useRef(true);
    const lastScrollTopRef = useRef(0);
    const hasCompletedRef = useRef(false);

    useEffect(() => {
        let animationFrameId: number;

        const handleScroll = () => {
            if (!containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            const currentScrollTop = window.scrollY || document.documentElement.scrollTop;

            if (currentScrollTop > lastScrollTopRef.current) {
                isScrollingDownRef.current = true;
            } else if (currentScrollTop < lastScrollTopRef.current) {
                isScrollingDownRef.current = false;
            }
            lastScrollTopRef.current = currentScrollTop;

            const windowHeight = window.innerHeight;
            const scrolled = -rect.top;

            if (scrolled < windowHeight * 0.2) {
                hasCompletedRef.current = false;
            }

            const animationZone = windowHeight * 2.5;

            let p = scrolled / animationZone;
            p = Math.max(0, Math.min(1, p));

            if (hasCompletedRef.current && isScrollingDownRef.current) {
                p = 1;
            }

            targetRef.current = p;
        };

        const loop = () => {
            let target = targetRef.current;
            const current = progressRef.current;

            if (current > 0.99) {
                hasCompletedRef.current = true;
            }

            if (hasCompletedRef.current && isScrollingDownRef.current) {
                target = 1;
            }
            else if (isScrollingDownRef.current && current > 0.15 && target < 1) {
                target = 1;
            }

            const diff = target - current;
            const lerpFactor = isScrollingDownRef.current ? 0.012 : 0.15;

            if (Math.abs(diff) > 0.0001) {
                const next = current + diff * lerpFactor;
                progressRef.current = next;
                setProgress(next);
            }

            animationFrameId = requestAnimationFrame(loop);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        loop();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    const pShadowRaw = Math.max(0, progress - 0.15);
    const pShadow = Math.min(1, pShadowRaw / 0.5);
    const shadowOpacity = pShadow;

    const pTextRaw = Math.max(0, progress - 0.15);
    const pText = Math.min(1, pTextRaw / 0.45);
    const textOpacity = pText;
    const textScale = 0.8 + (pText * 0.2);

    const p2Raw = Math.max(0, progress - 0.65);
    const p2 = Math.min(1, p2Raw / 0.15);
    const opacity2 = p2;
    const blur2 = Math.max(0, 10 * (1 - p2 * 3));
    const transY2 = 30 * (1 - p2);
    const scale2 = 1.4 - (0.4 * p2);
    const transX2 = 5 * (1 - p2);

    const pUIRaw = Math.max(0, progress - 0.8);
    const pUI = Math.min(1, pUIRaw / 0.1);
    const opacityUI = pUI;
    const transYUI = 20 * (1 - pUI);

    const handleBtnMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        e.currentTarget.style.setProperty('--x', `${e.clientX - rect.left}px`);
        e.currentTarget.style.setProperty('--y', `${e.clientY - rect.top}px`);
    };

    return (
        <div className={styles.container} ref={containerRef}>
            <div className={styles.stickyWrapper}>

                {shadowOpacity > 0 && (
                    <div className={styles.shadowBg} style={{ opacity: shadowOpacity }} />
                )}

                <div className={styles.textWrapper} style={{ opacity: textOpacity, transform: `scale(${textScale})` }}>
                    <h1 className={styles.shopText}>Shop</h1>
                </div>

                <img
                    src="/assets/backgounds/sp_002_aw.png"
                    alt="Foreground"
                    className={styles.layer2}
                    style={{
                        opacity: opacity2,
                        filter: `blur(${blur2}px)`,
                        transform: `scale(${scale2}) translateY(${transY2}%) translateX(${transX2}%)`
                    }}
                />

                <div className={styles.uiLayer} style={{ opacity: opacityUI, transform: `translateY(${transYUI}px)` }}>

                    <div className={styles.centerGroup}>
                        <button
                            className={styles.shopButton}
                            onMouseMove={handleBtnMouseMove}
                            onClick={() => window.location.href = '/aw/shop'}
                        >
                            <span>Shop</span>
                            <svg width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
                                <line x1="3" y1="6" x2="21" y2="6" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                        </button>
                        <span className={styles.subText}>Ver toda la colección</span>
                    </div>

                    <img
                        src="/assets/icons/aw_icons/001_nk_vba_link.png"
                        alt="VBA Icon"
                        className={styles.iconV}
                        onClick={() => window.open('https://nikoven.com', '_blank')}
                    />

                    <img
                        src="/assets/icons/aw_icons/002_aruba_link.png"
                        alt="Aruba Icon"
                        className={styles.iconA}
                        onClick={() => window.open('https://www.aruba.com', '_blank')}
                    />

                </div>

            </div>
        </div>
    );
};
